<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 0; " class="flex justify-between">
			<Form ref="searchForm" :model="searchForm" label-position="left" :label-width="70" inline>
				<FormItem label="会员手机"><Input type="text" v-model="searchForm.mobile" placeholder="手机号码" /></FormItem>
				<FormItem label="变动类型">
					<Select v-model="searchForm.type" clearable>
						<Option value="1">增加</Option>
						<Option value="2">减少</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
			</Form>
			<Button type="warning" size="large" @click="showModalScoreAction()">增减会员积分</Button>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row }" slot="user">
				<div class="flex">
					<div class=" padding-top-xs">
						<Avatar :src="'http://cjb.xahulian.com/'+ row.user.avatar " size="48" v-if="row.user.avatar" />
						<Avatar icon="ios-person" size="48" v-else />
					</div>
					<div class="padding-left-sm padding-top-xs text-left">
						<span class="text-lg">{{row.user.nickname}}</span><br />
						<span class="text-blue">{{row.user.mobile}}</span>
					</div>
				</div>
			</template>
			<template slot-scope="{ row }" slot="type">
				<Tag color="success" v-if="row.type=='1'">增加</Tag>
				<Tag color="warning" v-if="row.type=='2'">减少</Tag>
			</template>
			<template slot-scope="{ row }" slot="score">
				<span class="text-green text-bold" v-if="row.type=='1'">+{{row.score}}</span>
				<span class="text-orange text-bold" v-if="row.type=='2'">-{{row.score}}</span>
			</template>
			<template slot-scope="{ row }" slot="yue">
				<span class="text-blue text-bold">{{row.yue}}</span>
			</template>
			<template slot-scope="{ row }" slot="action">
				<router-link tag="a" :to="{ path: 'view/'+row.id }">
					<Button type="primary">
						查看
					</Button>
				</router-link>
			</template>

			<template slot="header">
				<div class="flex justify-between">
					<div span="12">
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
		<Modal v-model="modalScoreAction" title="积分变动" :footer-hide="true" :width="520">
			<div style="position: relative;" class="padding-right-xl padding-tb">
				<Form ref="formScoreAction" :model="formScoreAction" label-position="right" :label-width="100" label-colon>
					<FormItem label="会员信息" required>
						<Input v-model="formScoreAction.mobile" :maxlength="11" placeholder="会员绑定的手机号" style="width:250px;"></Input>
						<Button @click="searchUser()">查找</Button>
						<div style="position: relative;" class="padding-top">
							<div class="padding-tb-sm" v-if="!formScoreAction.user">
								请先输入会员绑定的手机号进行查找
							</div>
							<div class="flex" v-else>
								<div class=" padding-top-xs">
									<Avatar :src="'http://cjb.xahulian.com/'+ formScoreAction.user.avatar " size="48" v-if="formScoreAction.user.avatar" />
									<Avatar icon="ios-person" size="48" v-else />
								</div>
								<div class="padding-left-sm padding-top-xs text-left" style="line-height:25px">
									<span class="text-lg">{{formScoreAction.user.nickname}}</span><br />
									<span class="text-blue">{{formScoreAction.user.mobile}}</span>
								</div>
							</div>
							<Spin fix v-if="loadingScoreSearchUser">
								<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
								<div>处理中...</div>
							</Spin>
						</div>
					</FormItem>
					<FormItem label="操作类型" style="width:200px;" required>
						<Select v-model="formScoreAction.type">
							<Option value="1">增加</Option>
							<Option value="2">减少</Option>
						</Select>
					</FormItem>
					<FormItem label="变动积分" required>
						<Input v-model="formScoreAction.score" :maxlength="6" placeholder="变动的积分数" style="width:100px;"></Input>
					</FormItem>
					<FormItem label="记账描述" required>
						<Input v-model="formScoreAction.name" :maxlength="6" placeholder="简短日志一句话描述"></Input>
					</FormItem>
					<FormItem label="备注说明">
						<Input v-model="formScoreAction.remark" type="textarea" :rows="5" show-word-limit :maxlength="140" placeholder="备注说明"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="submitFormScoreAction('formScoreAction')">提交</Button>
						<Button style="margin-left: 8px" @click="modalScoreAction=false">取消</Button>
					</FormItem>
				</Form>
				<Spin fix v-if="loadingScoreAction">
					<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
					<div>处理中...</div>
				</Spin>
			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						width: 58
					},
					{
						title: '会员',
						align: 'center',
						slot: 'user',
						width: 250
					},
					{
						title: '类型',
						slot: 'type',
						align: 'center'
					},
					{
						title: '变动积分',
						slot: 'score',
						align: 'center'
					},
					{
						title: '变动后结余',
						slot: 'yue',
						align: 'center'
					},
					{
						title: '说明',
						key: 'name',
						align: 'center'
					},
					{
						title: '时间',
						key: 'time',
						align: 'center'
					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					type: '',
					nickname: ''
				},
				modalScoreAction: false,
				loadingScoreAction: false,
				loadingScoreSearchUser: false,
				formScoreAction: {
					user: null,
					mobile: '',
					type: '1',
					score: 0,
					remark: ''
				}
			};
		},
		methods: {
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/score/mingxi.php?a=list', this.$qs.stringify(this.searchForm)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			},
			showModalScoreAction() {
				this.modalScoreAction = true;
				this.formScoreAction = {
					user: null,
					mobile: '',
					type: '1',
					score: 0,
					remark: ''
				};
			},
			searchUser() {
				var that = this;
				if (this.formScoreAction.mobile == '') {
					this.$Message.error({
						content: '请填写会员绑定的手机号。',
						duration: 3,
						closable: true

					});
					return false;
				}
				this.loadingScoreSearchUser = true;
				this.$http.post('/server/api/client/score/index.php?a=scoresearchuser', this.$qs.stringify({
					mobile: this.formScoreAction.mobile
				})).then(
					res => {
						this.loadingScoreSearchUser = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.formScoreAction.user = res.data.data;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingScoreSearchUser = false;
						this.$Message.error('系统错误');
					}
				);
			},
			submitFormScoreAction() {
				var that = this;
				if (!this.formScoreAction.user) {
					this.$Message.error({
						content: '请填写会员绑定的手机号后进行查找。',
						duration: 3,
						closable: true
					});
					return false;
				}
				if (this.formScoreAction.score <= 0) {
					this.$Message.error({
						content: '请填写变得积分：不小于1。',
						duration: 3,
						closable: true
					});
					return false;
				}
				this.loadingScoreAction = true;
				this.$http.post('/server/api/client/score/index.php?a=scoreaction', this.$qs.stringify(this.formScoreAction)).then(
					res => {
						this.loadingScoreAction = false;
						if (res.data.result == 'ok') {
							this.$Message.success('操作成功!');
							this.modalScoreAction = false;
							this.searchForm = {
								page: 1,
								size: 20,
								total: 0,
								type: '',
								nickname: ''
							};
							this.loadinfos();
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loadingScoreAction = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			this.loadinfos();
		}
	};
</script>

<style>
	.demo-spin-icon-load {
		font-size: 5em;
		animation: ani-demo-spin 1s linear infinite;
	}
</style>
